import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from 'store';
/**
 * APIのローディング共通の状態
 */
interface LoaderState {
  loading: boolean;
}

/**
 * APIのローディング共通の初期状態
 */
const initialState: LoaderState = {
  loading: false,
};

/**
 * APIのローディング共通の slice(reducer + action)
 */
export const loaderSlice = createSlice({
  name: 'common',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
  },
});

/**
 * APIのローディング共通 action
 */
export const loaderActions = loaderSlice.actions;

/**
 * APIのローディング共通の selector
 */
export const loaderSelectors = {
  loading: (state: RootState) => state.loader.loader.loading,
};
